import { render, staticRenderFns } from "./StatsAttribution.vue?vue&type=template&id=1bbbba9b"
import script from "./StatsAttribution.vue?vue&type=script&lang=js"
export * from "./StatsAttribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports